import { render, staticRenderFns } from "./button_language.vue?vue&type=template&id=9438c8dc&scoped=true"
import script from "./button_language.vue?vue&type=script&lang=js"
export * from "./button_language.vue?vue&type=script&lang=js"
import style0 from "./button_language.vue?vue&type=style&index=0&id=9438c8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9438c8dc",
  null
  
)

export default component.exports